module.exports = __webpack_public_path__ + "img/email_hover.71854a8.svg";